import * as React from 'react';
import { ILxsUserRoleData } from './lxs-user-role.data';
import { ILxsUserRoleProps } from './lxs-user-role.props.autogenerated';

export interface ILxsUserRoleViewProps extends ILxsUserRoleProps<ILxsUserRoleData> {}

/**
 *
 * LxsUserRole component
 * @extends {React.PureComponent<ILxsUserRoleProps<ILxsUserRoleData>>}
 */
class LxsUserRole extends React.PureComponent<ILxsUserRoleProps<ILxsUserRoleData>> {
    public render(): JSX.Element | null {
        return null;
    }
}

export default LxsUserRole;
